import styled from "../../../../client-utils/styled/index.js";
import Typography from "../../../../components/atoms/Typography/index.js";
const CORE_COMPONENT_NAME = "ProductVersion";
export const ProductVersionTypography = styled(Typography, {
    name: CORE_COMPONENT_NAME,
    slot: " ProductVersionTypography",
})(({ theme }) => ({
    color: theme.vars.palette.surface.onVariant,
    textAlign: "center",
}));
